export default "__VITE_ASSET__EbKI6lut__"